import React from 'react';
import ReactDOM from 'react-dom';

var ContentEditable = React.createClass({

  render() {
    const markup = this.props.html || '';
    return <input
      type="text"
      className="ContentEditable"
      onFocus={this.selectElementContents}
      onInput={this.emitChange}
      onBlur={this.emitChange}
      defaultValue={markup}/>;
  },

  shouldComponentUpdate(nextProps) {
    return nextProps.html !== ReactDOM.findDOMNode(this).value;
  },

  componentDidMount() {
    if (this.props.focus) {
      if (this.props.selectAllOnFocus) {
        this.selectElementContents();
      }
      ReactDOM.findDOMNode(this).focus();
    }
  },

  componentDidUpdate() {
    if (this.props.html !== ReactDOM.findDOMNode(this).value) {

      ReactDOM.findDOMNode(this).value = this.props.html;
    }
  },

  emitChange(evt) {
    let html = ReactDOM.findDOMNode(this).value;
    if (this.props.onChange && html !== this.lastHtml) {
      evt.target = { value: html };
      this.props.onChange(evt);
    }
    this.lastHtml = html;
  },

  selectElementContents() {
    ReactDOM.findDOMNode(this).select();
  }

});

export default ContentEditable;



// WEBPACK FOOTER //
// ./src/components/ContentEditable.js